import type { ISODate } from "@inrev/common";
import { DateTime } from "luxon";
import { type FC, useId } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

type PriorPeriodIndicatorProps = {
	sourceStatementDate: ISODate;
	tooltipId?: string;
};

export const PriorPeriodIndicator: FC<PriorPeriodIndicatorProps> = ({
	sourceStatementDate,
	tooltipId,
}) => {
	const generatedId = useId();
	const id = tooltipId ?? generatedId;

	return (
		<>
			<sup
				data-testid="prior-period-indicator"
				data-tooltip-id={id}
				data-tooltip-content={`Prior period on statement dated ${DateTime.fromISO(sourceStatementDate).toFormat("MM/dd/yyyy")}`}
				className="ml-0.5"
			>
				P
			</sup>
			<ReactTooltip id={id} style={{ zIndex: 9999 }} />
		</>
	);
};
